import { Box, Typography, useTheme } from "@mui/material";
import type { FC } from "react";
import { ChatAttachmentFile } from "web_myplann/Chat/Components/ChatAttachmentFile";
import { ChatAttachmentImage } from "web_myplann/Chat/Components/ChatAttachmentImage";
import { ChatMessageBubble } from "web_myplann/Chat/Components/ChatMessageBubble";
import { formatChatTime } from "web_myplann/Chat/Helpers/chatFormatting";
import type { ChatMessageView } from "web_myplann/Chat/Types/chatMessage";
import { InitialsAvatar } from "web_myplann/Shared/Components/InitialsAvatar";

type Props = {
	message: ChatMessageView;
	advisorName: string;
	advisorPhoto?: string;
};

export const ChatRecipientMessage: FC<Props> = ({
	message,
	advisorName,
	advisorPhoto,
}) => {
	const theme = useTheme();
	const {
		avatar: avatarTheme,
		message: messageTheme,
		recipient,
		timestamp,
	} = theme.chat;
	const { content, attachments } = message;

	const avatar = (
		<Box
			width={avatarTheme.size}
			flexShrink={0}
			alignSelf="flex-end"
			mr={avatarTheme.gap}
		>
			<Box className="chat_group_tail">
				<InitialsAvatar
					name={advisorName}
					photo={advisorPhoto}
					size={avatarTheme.size}
				/>
			</Box>
		</Box>
	);

	return (
		<ChatMessageBubble
			alignment="start"
			startAdornment={avatar}
			pending={message.pending}
		>
			{attachments.map((attachment) =>
				attachment.isImage ? (
					<ChatAttachmentImage
						key={attachment.id}
						attachmentId={attachment.id}
						fileName={attachment.fileName}
					/>
				) : (
					<ChatAttachmentFile
						key={attachment.id}
						fileName={attachment.fileName}
						backgroundColor={recipient.background}
						boxShadow={theme.shadows[recipient.elevation]}
					/>
				),
			)}

			{content && (
				<Typography
					className="chat_bubble"
					variant="body2"
					color={recipient.textColor}
					px={messageTheme.paddingX}
					py={messageTheme.paddingY}
					lineHeight={messageTheme.lineHeight}
					bgcolor={recipient.background}
					boxShadow={theme.shadows[recipient.elevation]}
				>
					{content}
				</Typography>
			)}

			<Typography
				className="chat_group_tail"
				variant="hint"
				pl={timestamp.inset}
			>
				{formatChatTime(message.createdAt)}
			</Typography>
		</ChatMessageBubble>
	);
};
